import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DragDataClass;
function DragData() {
  if (DragDataClass === VOID) {
    class $ {
      constructor(label, typeToData, dragShadow) {
        return new.target.new_com_lightningkite_kiteui_models_DragData_1zeh93_k$(label, typeToData, dragShadow);
      }
      static new_com_lightningkite_kiteui_models_DragData_1zeh93_k$(label, typeToData, dragShadow) {
        dragShadow = dragShadow === VOID ? null : dragShadow;
        var $this = createThis(this);
        $this.label_1 = label;
        $this.typeToData_1 = typeToData;
        $this.dragShadow_1 = dragShadow;
        return $this;
      }
      static new_com_lightningkite_kiteui_models_DragData_uulv8r_k$(label, mimeType, data, dragShadow) {
        dragShadow = dragShadow === VOID ? null : dragShadow;
        return this.new_com_lightningkite_kiteui_models_DragData_1zeh93_k$(label, mapOf(to(mimeType, data)), dragShadow);
      }
      get_6bo4tg_k$(mimeType) {
        return this.typeToData_1.get_wei43m_k$(mimeType);
      }
      toString() {
        return 'DragData(label=' + this.label_1 + ', typeToData=' + toString(this.typeToData_1) + ', dragShadow=' + toString_0(this.dragShadow_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.label_1);
        result = imul(result, 31) + hashCode(this.typeToData_1) | 0;
        result = imul(result, 31) + (this.dragShadow_1 == null ? 0 : this.dragShadow_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DragData()))
          return false;
        if (!(this.label_1 === other.label_1))
          return false;
        if (!equals(this.typeToData_1, other.typeToData_1))
          return false;
        if (!equals(this.dragShadow_1, other.dragShadow_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DragData');
    DragDataClass = $;
  }
  return DragDataClass;
}
var DragEventClass;
function DragEvent() {
  if (DragEventClass === VOID) {
    class $ {
      constructor(data, xInView, yInView) {
        this.data_1 = data;
        this.xInView_1 = xInView;
        this.yInView_1 = yInView;
      }
      toString() {
        return 'DragEvent(data=' + this.data_1.toString() + ', xInView=' + this.xInView_1 + ', yInView=' + this.yInView_1 + ')';
      }
      hashCode() {
        var result = this.data_1.hashCode();
        result = imul(result, 31) + getNumberHashCode(this.xInView_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.yInView_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DragEvent()))
          return false;
        if (!this.data_1.equals(other.data_1))
          return false;
        if (!equals(this.xInView_1, other.xInView_1))
          return false;
        if (!equals(this.yInView_1, other.yInView_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DragEvent');
    DragEventClass = $;
  }
  return DragEventClass;
}
//region block: exports
export {
  DragData as DragData2helsigoeiabk,
  DragEvent as DragEventn7vmft816tmz,
};
//endregion

//# sourceMappingURL=DragData.mjs.map
